module.exports = __webpack_public_path__ + "img/md5-normal6.e6a798eb.png";